import React, { useEffect, useContext } from "react"
import { useNavigate, useParams } from 'react-router-dom'

import StepIndicator from '../../components/step-indicator'
import CreditCardDetails from '../../components/credit-card-details'
import CreditCardSubmitButtons from '../../components/credit-card-submit-buttons'

import MembershipFormContext from '../../context/membership'
import { getSS, loadIndexPage } from '../../helpers'

const CardDetails: React.FC = (props: any) => {

  const navigate = useNavigate()
  const params = useParams()
  const membershipForm = useContext(MembershipFormContext)
  const membership_form = (window as any).KEW.collections.membership_form[0]
  const url = membership_form.private_form ? 'private/' + params.url : params.url
  let membership = getSS('membership')

  if (!membership || membership.process_payment) {
    loadIndexPage(navigate, url)
  }

  useEffect(() => {
    document.title = 'Card details - ' + (window as any).KEW.collections.membership_form[0].meta_title
  })

  useEffect(() => {
    membershipForm.setCurrentStep(4)
  }, [membershipForm])

  return (
    <>
      <form name="membershipForm">
        <StepIndicator />
        <CreditCardDetails url={params.url} />
        <CreditCardSubmitButtons />
      </form>
    </>
  )
}

export default CardDetails